module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded"
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showDialog
    }
  }, [_vm._v("添加面额(" + _vm._s(_vm.dataList.length) + "/14)")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.dataList,
      "height": _vm.wheight - 200
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "money",
      "label": "固定面额数(元)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠送"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ruleType == 'money') ? _c('span', [_vm._v("充值送钱")]) : _vm._e(), _vm._v(" "), (scope.row.ruleType == 'point') ? _c('span', [_vm._v("充值送积分")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠送说明"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.ruleType == 'money') ? _c('span', [_vm._v("充值" + _vm._s(scope.row.money) + "元送" + _vm._s(scope.row.ruleData) + "元")]) : _vm._e(), _vm._v(" "), (scope.row.ruleType == 'point') ? _c('span', [_vm._v("充值" + _vm._s(scope.row.money) + "元送" + _vm._s(scope.row.ruleData) + "积分")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.edit(scope.row, scope.$index)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              return _vm.remove(scope.row, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加面额",
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "before-close": _vm.cancelAction
    }
  }, [_c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "固定面额数(元)",
      "prop": "fixed_money"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    model: {
      value: (_vm.form.fixed_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "fixed_money", $$v)
      },
      expression: "form.fixed_money"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠送"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.form.rule_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "rule_type", $$v)
      },
      expression: "form.rule_type"
    }
  }, _vm._l((_vm.giftType), function(item, index) {
    return _c('el-option', {
      key: item.rule_type,
      attrs: {
        "label": item.text,
        "value": item.rule_type
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.rule_type == 'money'),
      expression: "form.rule_type == 'money'"
    }],
    attrs: {
      "label": "赠送金额(元)"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.rule_data),
      callback: function($$v) {
        _vm.$set(_vm.form, "rule_data", $$v)
      },
      expression: "form.rule_data"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.rule_type == 'point'),
      expression: "form.rule_type == 'point'"
    }],
    attrs: {
      "label": "赠送积分(分)"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    model: {
      value: (_vm.form.rule_data),
      callback: function($$v) {
        _vm.$set(_vm.form, "rule_data", $$v)
      },
      expression: "form.rule_data"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0b258e1c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b258e1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeddeposit/storedvalue.vue
// module id = 2454
// module chunks = 0